import React, { useState } from "react";
import ChangeList from "./ChangeList";
import ChangeView from "./ChangeView";

const Changes = () => {

    const [selectedChangeId, setSelectedChangeId] =
        useState(null);

    /*
     * Open selected change directly
     */
    const onView = (changeId) => {

        console.log("View Change:", changeId);

        setSelectedChangeId(changeId);
    };

    /*
     * Return to change list
     */
    const onBack = () => {

        setSelectedChangeId(null);
    };


    /*
     * Show selected change directly
     * instead of showing it below the list
     */
    if (selectedChangeId) {

        return (
            <ChangeView
                changeId={selectedChangeId}
                onBack={onBack}
            />
        );
    }


    return (
        <ChangeList
            onView={onView}
        />
    );
};

export default Changes;